import axios from 'axios'
import type {
  EventData,
  EventFilter,
  GlobalContext,
  HawkSearchEvent,
} from '../types/events'
import { BaseProvider } from './base'

// declare const HawkSearch: {
//   BaseUrl: string
//   HawkUrl: string
//   TrackingUrl: string
//   RecommenderUrl: string
//   ClientGuid: string
// }

export class HawkSearchProvider implements BaseProvider {
  // private isInitialized = false
  public eventFilter?: EventFilter

  public initialize(): void {
    // if (this.isInitialized) return
    // Initial implementation using Hawk SDK. not needed now.
    // const trackingUrl = import.meta.env.VITE_HAWKSEARCH_TRACKING_URL as string
    // const hawkUrl = import.meta.env.VITE_HAWKSEARCH_HAWK_URL as string
    // const recommenderUrl = import.meta.env
    //   .VITE_HAWKSEARCH_RECOMMENDER_URL as string
    // const clientGuid = import.meta.env.VITE_HAWKSEARCH_CLIENT_GUID as string
    // const configScript = document.createElement('script')
    // configScript.async = true
    // configScript.type = 'application/javascript'
    // configScript.textContent = `
    //   (function (HawkSearch, undefined) {
    //     HawkSearch.BaseUrl = '';
    //     HawkSearch.TrackingUrl = '${trackingUrl}';
    //     HawkSearch.HawkUrl = '${hawkUrl}';
    //     HawkSearch.RecommenderUrl = '${recommenderUrl}';
    //     HawkSearch.ClientGuid = '${clientGuid}';
    //     if (HawkSearch.BaseUrl === '') {
    //       HawkSearch.BaseUrl = HawkSearch.HawkUrl;
    //     }
    //     if ('https:' === document.location.protocol) {
    //       HawkSearch.BaseUrl = HawkSearch.BaseUrl.replace('http://', 'https://');
    //       HawkSearch.HawkUrl = HawkSearch.HawkUrl.replace('http://', 'https://');
    //       HawkSearch.TrackingUrl = HawkSearch.TrackingUrl.replace('http://', 'https://');
    //       HawkSearch.RecommenderUrl = HawkSearch.RecommenderUrl.replace('http://', 'https://');
    //     }
    //   })((window.HawkSearch = window.HawkSearch || {}));
    // `
    // document.body.appendChild(configScript)
    // const sdkScript = document.createElement('script')
    // sdkScript.type = 'application/javascript'
    // sdkScript.async = true
    // sdkScript.src = `${hawkUrl}/includes/hawksearch.min.js`
    // document.body.appendChild(sdkScript)
    // this.isInitialized = true
  }

  public async trackEvent(
    _eventName: string,
    eventData: HawkSearchEvent[] | EventData
  ): Promise<void> {
    const trackingUrl = import.meta.env.VITE_HAWKSEARCH_TRACKING_URL as string

    if (!trackingUrl || !Array.isArray(eventData)) return

    try {
      const clientGuid = import.meta.env.VITE_HAWKSEARCH_CLIENT_GUID as string
      await Promise.all(
        eventData.map((data) =>
          axios.post(trackingUrl, data, {
            headers: {
              'X-HawkSearch-ClientGuid': clientGuid,
            },
          })
        )
      )
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('[HawkSearch] Failed to track event:', error)
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public setGlobalContext(_context: GlobalContext): void {}

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public clearGlobalContext(_keys?: string[]): void {}
}

export const hawkSearchProvider = new HawkSearchProvider()
